import reduxConnector from 'root/src/shared/util/reduxConnector'

import staticPageTypeSelector from 'root/src/client/logic/static/selectors/staticPageTypeSelector'
import pageContentSelector from 'root/src/client/logic/static/selectors/pageContentSelector'
import sharedUrlSelector from 'root/src/client/logic/static/selectors/sharedUrlSelector'
import stepperHeaderItemsSelector from 'root/src/client/logic/static/selectors/stepperHeaderItemsSelector'
import infoItemsSelector from 'root/src/client/logic/static/selectors/infoItemsSelector'
import dareExamplesItemsSelector from 'root/src/client/logic/static/selectors/dareExamplesItemsSelector'
import featureItemsSelector from 'root/src/client/logic/static/selectors/featureItemsSelector'
import statsItemsSelector from 'root/src/client/logic/static/selectors/statsItemsSelector'
import buttonSelector from 'root/src/client/logic/static/selectors/buttonSelector'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import sliderWidthSelector from 'root/src/client/logic/app/selectors/sliderWidthSelector'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import { selectedTabSelector } from 'root/src/client/logic/tab/selectors/selectedTabSelector'
import { marketPlaceTabsSelector } from 'root/src/client/logic/tab/selectors/tabsSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'
import buttonWithHoverSelector from 'root/src/client/logic/static/selectors/buttonWithHoverSelector'
import accountSettingsButtonsSelector from 'root/src/client/logic/static/selectors/accountSettingsButtonsSelector'
import oauthedPlatformsSelector from 'root/src/client/logic/creatorData/selectors/oauthedPlatformsSelector'
import isBrandUserSelector from 'root/src/client/logic/static/selectors/isBrandUserSelector'
import setSelectedTabEndpointId from 'root/src/client/logic/tab/thunk/setSelectedTabEndpointId'
import setSortFilterEmbedded from 'root/src/client/logic/embedded/thunks/setSortFilterEmbedded'
import oauthAuthenticate from 'root/src/client/logic/auth/thunks/oauthAuthenticate'
import userRoleSelector from 'root/src/client/logic/auth/selectors/userRoleSelector'
import dissocShareUrl from 'root/src/client/logic/static/thunks/dissocShareUrl'
import maxWidthSelector from 'root/src/client/logic/static/selectors/maxWidthSelector'
import brandSuccessPageIdSelector from 'root/src/client/logic/static/selectors/brandSuccessPageIdSelector'
import querySelector from 'root/src/client/logic/route/selectors/querySelector'
import buttonsSelector from 'root/src/client/logic/static/selectors/buttonsSelector'
import tokensSelector from 'root/src/client/logic/api/selectors/tokensSelector'
import linkSelector from 'root/src/client/logic/static/selectors/linkSelector'
import stepperItemsSelector from 'root/src/client/logic/static/selectors/stepperItemsSelector'
import clearModal from 'root/src/client/logic/static/thunks/clearModal'
import setPreferredPlatform from 'root/src/client/logic/static/thunks/setPreferredPlatform'
import creatorPointsSelector from 'root/src/client/logic/userData/selectors/creatorPointsSelector'
import graphDescriptionsSelector from 'root/src/client/logic/static/selectors/graphDescriptionsSelector'
import currentRouteParams from 'root/src/client/logic/route/selectors/currentRouteParams'
import campaignDashboardDataSelector from 'root/src/client/logic/api/selectors/campaignDashboardDataSelector'
import moduleDataFilterSelector from 'root/src/client/logic/api/selectors/moduleDataFilterSelector'
import scrollItemBreakpointsSelector from 'root/src/client/logic/static/selectors/scrollItemBreakpointsSelector'

export default reduxConnector(
	[
		['staticPageType', staticPageTypeSelector],
		['sharedUrl', sharedUrlSelector],
		['pageContent', pageContentSelector],
		['stepperHeaderItems', stepperHeaderItemsSelector],
		['infoItems', infoItemsSelector],
		['dareExamplesItems', dareExamplesItemsSelector],
		['button', buttonSelector],
		['isMobileRes', isMobileResSelector],
		['sliderWidth', sliderWidthSelector],
		['tabs', marketPlaceTabsSelector],
		['selectedTab', selectedTabSelector],
		['isAuthenticated', isAuthenticated],
		['buttonWithHover', buttonWithHoverSelector],
		['oauthedPlatforms', oauthedPlatformsSelector],
		['isBrandUser', isBrandUserSelector],
		['userRole', userRoleSelector],
		['maxWidth', maxWidthSelector],
		['brandSuccessPageId', brandSuccessPageIdSelector],
		['query', querySelector],
		['buttons', buttonsSelector],
		['tokens', tokensSelector],
		['accountSettingsButtons', accountSettingsButtonsSelector],
		['link', linkSelector],
		['features', featureItemsSelector],
		['stepperItems', stepperItemsSelector],
		['stats', statsItemsSelector],
		['creatorPoints', creatorPointsSelector],
		['graphDescriptions', graphDescriptionsSelector],
		['currentRouteParams', currentRouteParams],
		['campaignDashboardData', campaignDashboardDataSelector],
		['moduleDataFilter', moduleDataFilterSelector],
		['scrollItemBreakpoints', scrollItemBreakpointsSelector],
	],
	[
		['setEndpoint', setSelectedTabEndpointId],
		['setInput', setSortFilterEmbedded],
		['displayModal', displayModal],
		['oauthAuthenticate', oauthAuthenticate],
		['dissocShareUrl', dissocShareUrl],
		['clearModal', clearModal],
		['setPreferredPlatform', setPreferredPlatform],
	],
)
